import { AxiosResponse } from 'axios'
import dayjs from 'dayjs'

import { _axios } from 'hooks/axios'
import { Holiday } from 'types/common'

const GET_HOLIDAYS = `../common/holidays`

export const commonApi = () => {
  const getHolidays = async (): Promise<AxiosResponse<Holiday[]>> => {
    return await _axios()
      .get(GET_HOLIDAYS)
      .then((res) => {
        res.data = res.data.holidays.map((holiday: Holiday) => ({
          ...holiday,
          date: dayjs(holiday.date),
        }))
        return res
      })
  }

  return {
    getHolidays,
  }
}
